const SocialAssetDataSource = {
  SaleReview: 'SaleReview',
  LeasingReview: 'LeasingReview',
  MortgageBrokingReview: 'MortgageBrokingReview',
  ExternalReview: 'ExternalReview',

  SalesNewListing: 'SalesNewListing',
  LeasingNewListing: 'LeasingNewListing',

  SalesSoldListing: 'SalesSoldListing',
  LeasingLeasedListing: 'LeasingLeasedListing',

  TempSalesCampaign: 'TempSalesCampaign',
  TempLeasingCampaign: 'TempLeasingCampaign',

  Awards: 'Awards',
} as const;

type SocialAssetDataSource = (typeof SocialAssetDataSource)[keyof typeof SocialAssetDataSource];

export { SocialAssetDataSource };
